import { noop } from 'rxjs';
import { ListType } from '../../helpers/dom/list';
import { IndentService, NULL_INDENT_SERVICE } from './indentService';

export { ListType } from '../../helpers/dom/list';

export interface ListService extends IndentService {
  readonly type: ListType | undefined;
  setType(type: ListType | undefined): void;
}

export const NULL_LIST_SERVICE: ListService = {
  ...NULL_INDENT_SERVICE,
  type: undefined,
  setType: noop,
};
